<template lang="pug">
  div
    template(v-if="Object.keys(nonEmptyRows).length && (model && Object.keys(model).length)")
      div(v-for="row in nonEmptyRows").tooltip__body-item.tes
        template(v-if='isArrayOfObject(model[row.value]) && isInfrastructure' )
          map-popup-table(:value="parseItem(model[row.value])")
          map-popup-infrastructure(
            v-if='isInfrastructure'
            :sumTones='Number(model.sum_tonn)'
            :objects='parseItem(model[row.value])'
          )
        template(v-else)
          span.info.info--grey {{row.label}}:
          span(v-html="model[row.value]" v-if="model[row.value]" ).info
          span(v-else) Нет данных
      .semibold(v-if="isInfrastructure && !model['objects_geo_waste']" ) В этом районе нет объектов указанного назначения
    template(v-else)

      span Нет данных
</template>
<script>
import MapPopupTable from './map-popup-table'
import MapPopupInfrastructure from './map-popup-infrastructure'

export default {
  name: 'popup-fields-rows',
  components: {
    MapPopupTable,
    MapPopupInfrastructure,
  },
  props: {
    rows: [Array, Object],
    excludedRows: {
      type: Array,
      default: () => [],
    },
    model: Object,
  },
  computed: {
    isInfrastructure() {
      return this.model.head === 'Достаточность объектов инфраструктуры'
    },
    nonEmptyRows() {
      const rowsObj = {}

      function filterEmpty(rows, model) {
        return rows.filter(({ value }) => {
          return (
            model[value] &&
            model[value] !== '-' &&
            model[value] !== null &&
            model[value] !== '' &&
            parseFloat(model[value]) !== 0 &&
            parseFloat(model[value]) !== -1
          )
        })
      }

      if (Array.isArray(this.rows) && this.rows?.length) {
        return filterEmpty(this.rows, this.model)
      }
      if (typeof this.rows === 'object') {
        const rows = Object.values(this.rows)
        if (!rows?.length) {
          return {}
        }

        filterEmpty(rows, this.model).map((row) => {
          if (!this.excludedRows.includes(row.value)) {
            rowsObj[row.value] = row
          }
        })
      }
      return rowsObj
    },
  },
  methods: {
    calcValue(row) {
      if (!this.model[row.value] || this.model[row.value] === '0') {
        return ' - '
      } else {
        return this.model[row.value]
      }
    },
    isArrayOfObject(item) {
      return item[0] === '['
    },
    parseItem(item) {
      return JSON.parse(item)
    },
  },
}
</script>
